import { Injectable } from '@angular/core';
import { Path } from 'src/app/utils/constant';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  constructor(
    private http: HttpService
  ) { }

  requestOtp(data?: any) {
    return this.http.public_post(Path.OTP.REQUEST, { body: data });
  }

  verifyOtp(data?: any) {
    return this.http.public_post(Path.OTP.VERIFY, { body: data });
  }
}
